import useAppSelector from "hooks/useAppSelector";
import { Fragment } from "react";

const AppLoading = () => {
    const { logoUrl } = useAppSelector((state) => state.config);

    return (
        <Fragment>
            <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/20">
                <div className="relative flex items-center justify-center">
                    {/* Logo ở giữa */}
                    <img
                        src={logoUrl || `${process.env.PUBLIC_URL}/images/no-image.png`}
                        alt="Logo"
                        className="w-16 h-16 z-10"
                    />

                    {/* Vòng tròn xoay quanh */}
                    <div className="absolute w-24 h-24 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                </div>
            </div>
        </Fragment>
    );
};

export default AppLoading;
